import { z } from 'zod';

import type { TFunction } from 'i18next';

const serviceSchema = z.object({
  option_id: z.number().optional(),
  id: z.number(),
  name: z.string(),
  price: z.number(),
  initial_count: z.number().optional(),
});

export function createOnlineCertificateFormSchema(
  t: TFunction,
  options: { hasLiqpayKey: boolean },
) {
  const { hasLiqpayKey } = options;

  return z
    .object({
      name: z
        .string({ message: t('validation_required') })
        .min(1, { message: t('validation_required') })
        .trim(),
      description: z.string().optional(),
      locations: z.array(z.string()),
      services: z.array(serviceSchema),
      order_position: z.string().min(1, { message: t('validation_required') }),
      active: z.boolean(),
      liqpay: z.string().nullable(),
      monopay: z.string().nullable(),
    })
    .superRefine((data, ctx) => {
      if (data.locations.length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t('validation_required'),
          path: ['locations'],
        });
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t('validation_select_locations_first'),
          path: ['services'],
        });
      } else if (data.services.length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t('validation_required'),
          path: ['services'],
        });
      }
    })
    .superRefine((data, ctx) => {
      if (hasLiqpayKey) {
        if (data.liqpay == null || data.liqpay === '') {
          ctx.addIssue({
            code: 'custom',
            message: t('validation_required'),
            path: ['liqpay'],
          });
        }
      } else {
        if (data.monopay == null || data.monopay === '') {
          ctx.addIssue({
            code: 'custom',
            message: t('validation_required'),
            path: ['monopay'],
          });
        }
      }
    });
}

type OnlineCertificateFormSchema = ReturnType<
  typeof createOnlineCertificateFormSchema
>;

export type OnlineCertificateFormValues = z.infer<OnlineCertificateFormSchema>;

export type OnlineCertificateFormInput = z.input<OnlineCertificateFormSchema>;
